export default function sanitizedFileName(name: string) {
    return (
        name
            // replace all white spaces
            .replace(/\s+/gi, "_")
            // replace any special chars
            .replace(/[^a-zA-Z0-9.\-\_]/gi, "_")
            // trim long underscores
            .replace(/_{2,}/gi, "_")
            // add the current timestamp in ms right before extension
            .replace(/.([a-zA-Z]+)$/gi, `.${Date.now()}.$1`)
            // lowercase
            .toLowerCase()
    )
}
